import React from 'react';
import { Users, FileSearch, Truck, PackageCheck, IndianRupee, Clock, Trophy } from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const AccountsDashboard = () => {
  const customTiles = [
    {
      id: 'hr-tile',
      title: 'HR — Wages & Productivity',
      description: 'Staff-wise operations dashboard, piece rates & wages report',
      icon: Users,
      iconBg: 'bg-indigo-600',
      route: '/sections/accounts/hr',
      testId: 'accounts-hr-tile',
      priority: true,
    },
    {
      id: 'gate-entry-details',
      title: 'Gate Entry Details',
      description: 'Track every gate inward, section assignment, and confirm invoice receipt in accounts',
      icon: FileSearch,
      iconBg: 'bg-amber-600',
      route: '/sections/accounts/gate-entry-details',
      testId: 'accounts-gate-entry-tile',
      priority: true,
    },
    {
      id: 'outward-gate-customer',
      title: 'Gate Entry Details — Customer Outward',
      description: 'Track every customer outward gate pass — boxes, quantities, driver & transport (view only)',
      icon: PackageCheck,
      iconBg: 'bg-emerald-600',
      route: '/sections/accounts/outward-gate-entries/customer',
      testId: 'accounts-outward-customer-tile',
      priority: true,
    },
    {
      id: 'outward-gate-regular',
      title: 'Gate Entry Details — Regular Outward',
      description: 'Track every regular outward gate entry (internal transfer & job worker) — view only',
      icon: Truck,
      iconBg: 'bg-sky-600',
      route: '/sections/accounts/outward-gate-entries/regular',
      testId: 'accounts-outward-regular-tile',
      priority: true,
    },
    {
      id: 'payslip',
      title: 'Payslip',
      description: 'Payroll matrix (qty/rate/amount) & printable staff payslips',
      icon: IndianRupee,
      iconBg: 'bg-emerald-600',
      route: '/sections/accounts/payslip',
      testId: 'accounts-payslip-tile',
      priority: true,
    },
    {
      id: 'hourly-staff-report',
      title: 'Hourly Staff Report',
      description: 'Live hourly pieces-completed per staff, split by day & night shift — with TV display',
      icon: Clock,
      iconBg: 'bg-violet-600',
      route: '/sections/accounts/hourly-staff-report',
      testId: 'accounts-hourly-staff-report-tile',
      priority: true,
    },
    {
      id: 'operation-rankings',
      requires_any: ['hourly-staff-report', 'payslip'],
      title: 'Staff Rankings by Operation',
      description: 'Monthly pieces per day / hour / % target per operation — flags staff low 3 months in a row',
      icon: Trophy,
      iconBg: 'bg-indigo-600',
      route: '/sections/accounts/operation-rankings',
      testId: 'accounts-operation-rankings-tile',
      priority: true,
    },
  ];
  return (
    <GenericSectionDashboard
      sectionName="Accounts Section"
      sectionId="accounts"
      sectionKey="Accounts"
      description="Financial Operations & Tracking"
      backRoute="/"
      customTiles={customTiles}
    />
  );
};

export default AccountsDashboard;
